















































































































































































































































import {
  defineComponent, reactive, computed, watch, ref,
} from '@vue/composition-api';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';
import { useRouter } from '@ideavivat/vivat-2';

import GroupAddressEditor from '@/components/GroupAddressEditor.vue';
import ViewOnlyGuard from '@/components/ViewOnlyGuard.vue';
import CommonDropzoneWithImageUpload from '@/components/CommonDropzoneWithImageUpload.vue';
import CommonCreatorGroupSelect from '@/components/Selector/CommonCreatorGroupSelect.vue';
import CommonHandicraftTypeSelector from '@/components/Selector/CommonHandicraftTypeSelector.vue';
import CommonYearSelector from '@/components/Selector/CommonYearSelector.vue';
import CommonMultiKnowledgeSelector from '@/components/Selector/CommonMultiKnowledgeSelector.vue';
import CommonGeolocationInput from '@/components/CommonInput/CommonGeolocationInput.vue';
import CommonTagsMultiSelector from '@/components/Selector/CommonTagsMultiSelector.vue';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import CommonImageTable from '@/components/Table/CommonImageTable.vue';

import CreatorGroupsQuery from '@/gql/getCreatorGroups.gql';
import getCreator from '@/gql/getCreator.gql';
import createCreator from '@/gql/createCreator.gql';
import updateCreator from '@/gql/updateCreator.gql';

import log from '@/table/log';

const CreatorEditor = defineComponent({
  setup() {
    /* ==== Get meta data ==== */
    const { route } = useRouter();
    // eslint-disable-next-line
    const mode = route.value.meta.mode;
    const modeDisplay = computed(() => {
      if (mode === 'create') return 'เพิ่ม';
      if (mode === 'edit') return 'แก้ไข';
      if (mode === 'view') return 'ดู';
      return '';
    });
    // Try to destructor but doesn't work Q^Q

    /* ===== Menu manager ===== */
    const editorMenu = [
      { id: 0, status: true, display: 'ประเภทผู้สร้างสรรค์ผลงาน' },
      { id: 1, status: false, display: 'ข้อมูลส่วนตัว' },
      { id: 2, status: false, display: 'ข้อมูลหัตถกรรม' },
      { id: 3, status: false, display: 'ข้อมูลประวัติและแนวคิด' },
      { id: 4, status: false, display: 'ภาพประกอบ' },
      { id: 5, status: false, display: 'ประวัติการแก้ไข' },
    ];

    function changeActiveMenu(index: number) {
      for (let i = 0; i < editorMenu.length; i += 1) {
        if (editorMenu[index].id === i) editorMenu[i].status = true;
        else editorMenu[i].status = false;
      }
    }

    /* ===== Form ===== */
    const form = reactive({
      // ---- Type ---- // ---- [0]
      handicraftType: undefined,
      creatorGroup: '',
      groupCode: undefined,
      recordedYear: '',
      itemNo: '',
      displayId: '',
      // ---- Profile ---- // ---- [1]
      firstName: '',
      lastName: '',
      gender: '',
      birthYear: '',
      isDead: false,
      // ---- Living place ---- //
      address: {
        province: {
          id: '',
          name: '',
        },
        postcode: '',
        district: {
          id: '',
          name: '',
        },
        amphur: {
          id: '',
          name: '',
        },
        address: '',
      },
      geolocation: {
        lat: '',
        long: '',
      },
      geolocationText: '',
      website: '',
      // ---- Information ---- // [2]
      honouredYear: '',
      knowledges: [''],
      tags: [],
      // ---- History, Idea ---- // [3]
      motto: '',
      bio: '',
      intellect: '',
      identity: '',
      method: '',
      preserve: '',
      preservationOfWisdom: '',
      footnote: '',
      // ---- Edit history ---- // [4]
      logs: [],
      // ---- Images ---- // [5]
      images: [{ isBlackBackground: false }],
      mainImage: undefined,
    });

    /* ==== Validate to submit button ==== */
    const validated = computed(() => {
      if (form.creatorGroup === '' || form.creatorGroup === undefined) return false;
      if (form.recordedYear === '' || form.recordedYear === undefined) return false;
      if (form.handicraftType === '' || form.handicraftType === undefined) return false;
      if (form.firstName === '' || form.firstName === undefined) return false;
      if (form.lastName === '' || form.lastName === undefined) return false;
      return true;
    });

    const saveModal = ref(null);
    function pendingSubmit() {
      if (validated.value) (saveModal.value as any).open();
    }
    // ========================= //

    function receiveKnowledges(arr: any[]) {
      if (!arr) return [];
      const temp = arr.map((item: any) => item.id);
      return temp;
    }

    const isQueryEnabled = ref(true);
    const { result: getCreatorResult } = useQuery(getCreator, computed(() => ({
      id: route.value.params.creatorId,
    })), () => ({
      fetchPolicy: 'network-only',
      enabled: isQueryEnabled.value,
    }));
    watch(getCreatorResult, () => {
      const creator = useResult(getCreatorResult, null, (data) => data.creator);
      const item = creator.value;
      if (item) isQueryEnabled.value = false; // if value is loaded, disable next query
      form.creatorGroup = item?.creatorGroup.id;
      form.recordedYear = item?.recordedYear + 543;
      form.handicraftType = item?.handicraftType.id;
      form.itemNo = item?.itemNo;
      // form.displayId: '',
      // ---- Profile ---- // ---- [1]
      form.firstName = item?.firstName;
      form.lastName = item?.lastName;
      form.gender = item?.gender;
      form.birthYear = item?.birthYear + 543;
      form.isDead = item?.isDead;
      // form.isDeath: false,
      // ---- Living place ---- //
      form.address.address = item?.groupAddress?.address === null ? '' : item?.groupAddress?.address;
      form.address.province.id = item?.groupAddress.province === null ? '' : item?.groupAddress.province?.id;
      form.address.amphur.id = item?.groupAddress.amphur === null ? '' : item?.groupAddress.amphur?.id;
      form.address.district.id = item?.groupAddress.district === null ? '' : item?.groupAddress.district?.id;
      form.address.postcode = item?.groupAddress?.postcode === null ? '' : item?.groupAddress?.postcode;
      form.geolocationText = `${item?.geolocation?.lat ? `${item?.geolocation.lat}, ` : ''}${item?.geolocation?.long ? item?.geolocation.long : ''}`;
      form.website = item?.website;
      // ---- Information ---- // [2]
      form.honouredYear = item?.honouredYear + 543;
      form.knowledges = receiveKnowledges(item?.knowledges) || [];
      form.tags = item?.tags || [];
      // ---- History, Idea ---- // [3]
      form.motto = item?.motto;
      form.bio = item?.bio;
      form.intellect = item?.intellect;
      form.identity = item?.identity;
      form.method = item?.method;
      form.preserve = item?.preserve;
      form.footnote = item?.footnote;
      // --- CAMEL CASE ----
      // eslint-disable-next-line
      form.preservationOfWisdom = item?.preservation_of_wisdom;
      // ---- History, Idea ---- // [4]
      form.logs = item?.logs;
      // ---- Image ---- // [5]
      form.images = item?.images;
    });

    // Display Creator group name
    const { result: creatorGroupResult, loading } = useQuery(CreatorGroupsQuery);
    const creatorGroups = useResult(creatorGroupResult, [], (data) => data.creatorGroups);
    const displayCreatorGroupName = computed(() => {
      if (!form.creatorGroup) return creatorGroups.value[0].name;
      return creatorGroups.value[parseInt(form.creatorGroup, 10) - 1].name;
    });

    const computedGeolocation = computed(() => {
      const text = form.geolocationText?.split(', ');
      if (!text) return { lat: 0.00, long: 0.00 };
      return {
        lat: parseFloat(text[0]),
        long: parseFloat(text[1]),
      };
    });

    const computedImages = computed(() => {
      const temp: any = [];
      // eslint-disable-next-line
      form.images?.forEach((element: any) => {
        temp.push(parseInt(element.id, 10));
      });
      return temp;
    });

    const computedKnowledges = computed(() => {
      const temp: any = [];
      // eslint-disable-next-line
      form.knowledges.forEach((element: any) => {
        temp.push(parseInt(element, 10));
      });
      return temp;
    });

    const creatorInput = computed(() => ({
      creatorGroup: form.creatorGroup,
      handicraftType: form.handicraftType,
      itemNo: form.itemNo || '',
      firstName: form.firstName || '',
      lastName: form.lastName || '',
      birthYear: parseInt(form.birthYear, 10) - 543 || (new Date(Date.now())).getFullYear(),
      isDead: form.isDead || false,
      gender: form.gender || 'male',
      tags: form.tags || [],
      images: computedImages.value,
      geolocation: computedGeolocation.value,
      groupAddress: {
        address: form.address.address || '',
        district: parseInt(form.address.district.id, 10) || null,
        amphur: parseInt(form.address.amphur.id, 10) || null,
        province: parseInt(form.address.province.id, 10) || null,
        postcode: form.address.postcode || '',
      },
      motto: form.motto,
      bio: form.bio,
      intellect: form.intellect,
      identity: form.identity,
      method: form.method,
      preserve: form.preserve,
      // --- CAMEL CASE ----
      // eslint-disable-next-line
      preservation_of_wisdom: form.preservationOfWisdom,
      footnote: form.footnote,
      knowledges: computedKnowledges.value,
      honouredYear: parseInt(form.honouredYear, 10) - 543 || (new Date(Date.now())).getFullYear(),
      recordedYear: parseInt(form.recordedYear, 10) - 543 || (new Date(Date.now())).getFullYear(),
      website: form.website || '',
    }));

    const createCreatorMutation = useMutation(createCreator,
      () => ({
        variables: {
          input: creatorInput.value,
        },
        refetchQueries: ['getCreators', 'getCreatorGroups'],
      }));

    const updateCreatorMutation = useMutation(updateCreator,
      () => ({
        variables: {
          id: route.value.params.creatorId,
          input: creatorInput.value,
        },
        refetchQueries: ['getCreators', 'getCreatorGroups'],
      }));

    // ==== Computed Mutation ==== //
    const computedMutation = computed(() => {
      if (mode === 'create') return createCreatorMutation;
      return updateCreatorMutation;
    });

    function onImageUploadDone(newImage: never) {
      if (!form.images) form.images = [];
      form.images.push(newImage);
    }

    return {
      onImageUploadDone,
      mode,
      displayCreatorGroupName,
      modeDisplay,
      editorMenu,
      changeActiveMenu,
      form,
      log,
      computedMutation,
      validated,
      pendingSubmit,
      saveModal,
    };
  },
  components: {
    GroupAddressEditor,
    ViewOnlyGuard,
    CommonDropzoneWithImageUpload,
    CommonCreatorGroupSelect,
    CommonHandicraftTypeSelector,
    CommonYearSelector,
    CommonMultiKnowledgeSelector,
    CommonGeolocationInput,
    CommonTagsMultiSelector,
    CommonConfirmDialog,
    CommonImageTable,
  },
  props: {
    role: {},
  },
});

export default CreatorEditor;
